export default __webpack_public_path__ + "static/media/elevate-bpn-4.9dfbfdd2.png";